<div class="fulfill-batch-list">
  <div class="fulfill-batch-list__header">
    <pdq-tabs-group (onChange)="setActiveTab($event)">
      <pdq-tab value="all" [label]="labels.all"></pdq-tab>
      <pdq-tab value="fulfillment_ready" [label]="labels.fulfillmentReady"></pdq-tab>
      <pdq-tab value="delivery_ready" [label]="labels.deliveryReady"></pdq-tab>
    </pdq-tabs-group>
    <div class="fulfill-batch-list__actions">
      <pdq-button
        label="Shipping manifests"
        icon="manifest"
        variant="ghost"
        iconColor="var(--on-surface-light)"
        size="medium"
        (onClick)="shippingManifests()"></pdq-button>
      <pdq-button label="Scan order" icon="scan" variant="dark" size="medium" (onClick)="scanLabel()"></pdq-button>
    </div>
  </div>
  <div class="section-wrapper">
    <section cdkScrollable>
      @if (activeTab !== 'delivery_ready') {
        <fulfill-batch-list-fulfillment-ready
          [pdqUsersList]="pdqUsersList"
          [batches]="batches.fulfillmentReady"
          [columns]="columns"></fulfill-batch-list-fulfillment-ready>
      }

      @if (activeTab !== 'fulfillment_ready') {
        <fulfill-batch-list-delivery-ready
          [batches]="batches.deliveryReady"
          [columns]="columns"></fulfill-batch-list-delivery-ready>
      }
    </section>
  </div>
</div>
